import React, { useEffect, useRef, useState } from 'react';
import propTypes from 'prop-types'
import styled from '@emotion/styled';
import { theme } from '../../../themes/default-theme';
import { Grid, Box } from '@mui/material';
import Text from '../../typography';

const ScriptInnerContainer = styled.div`
    > .MuiTypography-h4,
    > h4 {
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 8px;
        color: ${theme.palette.charcoal};
        ${theme.breakpoints.up('md')} {
            margin-bottom: 50px;
            font-size: 28px;
        }
        ${theme.breakpoints.down('sm')} {
            margin-bottom: 20px;
            font-size: 16px;
        }
    }
`

const Scripts = ({
    html = null,
    title = null,
    hTag
}) => {
    // Simple test script that creates interactive content
    const [headScripts, setHeadScripts] = useState([]);
    const [scriptsContent, setScriptsContent] = useState(html);
    const containerRef = useRef(null);

    const detachScript = (content) => {
        let scripts = [];
        var temp = document.createElement('div');
        temp.innerHTML = content;

        var tempScripts = temp.getElementsByTagName("customscript");
        var tempScriptsArr = Array.prototype.slice.call(tempScripts);
        tempScriptsArr.forEach(item => {

            scripts.push({
                src: item.getAttribute('src'),
                js: item.innerHTML
            })
        })
        return scripts
    }

    const loadScriptSrc = (src, onload) => {
        var tag = document.createElement('script');
        tag.async = true;
        tag.src = src;
        if (onload) tag.onload = onload;
        containerRef.current && containerRef.current.appendChild(tag);
    }

    const loadScriptContent = (content) => {
        var tag = document.createElement('script');
        tag.async = true;
        tag.innerHTML = content;
        containerRef.current && containerRef.current.appendChild(tag);
    }

    function afterCharacter(string, char) {
        return string.slice(string.indexOf(char) + 14);
      }

    useEffect(() => {
        const contentToUse = html;
        setScriptsContent(contentToUse?.replace(/customscript/g, 'script'));
    }, [html])

    useEffect(() => {
        // Only run script execution once after first render
        const executeScripts = () => {
            var allScripts = detachScript(scriptsContent);
            setHeadScripts(allScripts);
            
            // Execute scripts only on initial mount, in document order —
            // a src script blocks until loaded before the next script runs,
            // matching how the browser would run plain sequential <script> tags
            if (allScripts.length > 0) {
                const runFrom = (index) => {
                    if (index >= allScripts.length) return;
                    const item = allScripts[index];
                    if (item.src && item.src.length > 0) {
                        loadScriptSrc(item.src, () => runFrom(index + 1));
                    } else {
                        if (item.js) {
                            loadScriptContent(item.js);
                        }
                        runFrom(index + 1);
                    }
                };
                runFrom(0);
            } else {
                // Fallback to direct execution if no scripts were detected
                const scriptContent = html;
                if (scriptContent && scriptContent.includes('<customscript>')) {
                    const scriptCode = afterCharacter(scriptContent, '<customscript>').split('</customscript')[0];
                    loadScriptContent(scriptCode);
                }
            }
        };
        
        // Execute once with a small delay to ensure DOM is ready
        const timer = setTimeout(executeScripts, 100);
        
        // Clean up function to prevent memory leaks
        return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array ensures this only runs once on mount

    return (
        <Grid size={12}>
            <Box px={2}>
                <ScriptInnerContainer ref={containerRef}>
                    {title &&
                        <Text variant="h4" element={hTag ? hTag : 'h4'}>{title}</Text>
                    }
                    <div dangerouslySetInnerHTML={{ __html: scriptsContent }} />

                </ScriptInnerContainer>
            </Box>
        </Grid>
    );
};


Scripts.propTypes = {
    html: propTypes.string,
    title: propTypes.string
}



export default Scripts
